export const AiIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.67046 1.49886C8.58163 1.20277 8.30912 1 8 1C7.69088 1 7.41837 1.20277 7.32954 1.49886C6.82596 3.17732 6.17325 4.37429 5.27377 5.27377C4.37429 6.17325 3.17732 6.82596 1.49886 7.32954C1.20277 7.41837 1 7.69088 1 8C1 8.30912 1.20277 8.58163 1.49886 8.67046C3.17732 9.17404 4.37429 9.82672 5.27377 10.7262C6.17325 11.6257 6.82596 12.8226 7.32954 14.5011C7.41837 14.7972 7.69088 15 8 15C8.30912 15 8.58163 14.7972 8.67046 14.5011C9.17404 12.8226 9.82672 11.6257 10.7262 10.7262C11.6257 9.82672 12.8226 9.17404 14.5011 8.67046C14.7972 8.58163 15 8.30912 15 8C15 7.69088 14.7972 7.41837 14.5011 7.32954C12.8226 6.82596 11.6257 6.17325 10.7262 5.27377C9.82672 4.37429 9.17404 3.17732 8.67046 1.49886Z"
      fill="url(#paint0_linear_18742_14650)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_18742_14650"
        x1="11.7188"
        y1="2.09375"
        x2="3.84375"
        y2="13.6875"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#7251F1" />
        <stop offset="1" stopColor="#BD9EFF" />
      </linearGradient>
    </defs>
  </svg>
);
